import React, { useState } from "react";
import OilProductionmaterilsLog from "./oilProductionLog1";
import OilProductionSearch from "./OilProductionSearchRecords";
import { OilIntakeLogModel } from "../../models/oilProduction-model";


const OilProductionLog1: React.FC = () => {
  const [filteredData, setFilteredData] = useState<OilIntakeLogModel[]>([]);
    const [loading, setLoading] = useState(false);

  const handleSearch = (data: any[]) => {
    setFilteredData(data);
  };
  return (
    <div className="p-4 shadow-lg rounded-lg bg-white">
      <h3>Oil Production</h3>
      <OilProductionmaterilsLog />
        <div className="col-12 mb-4">
    <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container">
      {/* <OilProductionSearch onSearch={handleSearch} setLoading={setLoading} /> */}
    </div>
  </div>
    </div>
  );
};

export default OilProductionLog1;
